import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { CSVImporter } from '../../../components/CSVImporter';
import { CSVValidator } from '../../../components/CSVValidator';
import { FaFileImport, FaFileExport, FaInfoCircle, FaCheckDouble } from 'react-icons/fa';
import { notify } from '../../../utils/notifications';
const Container = styled.div `
  padding: 0;
`;
const Section = styled.div `
  margin-bottom: 2rem;
`;
const SectionHeader = styled.div `
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--border-color);
`;
const SectionTitle = styled.h2 `
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg {
    color: var(--accent-gold, #996515);
  }
`;
const InfoBox = styled.div `
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-left: 4px solid var(--accent-gold, #996515);
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
`;
const InfoTitle = styled.div `
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.75rem;

  svg {
    font-size: 1.25rem;
    color: var(--accent-gold, #996515);
  }
`;
const InfoContent = styled.div `
  font-size: 0.875rem;
  color: var(--text-secondary);
  line-height: 1.6;

  ul {
    margin: 0.5rem 0 0 0;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.25rem;
  }
`;
const ImportManagement = () => {
    return (_jsxs(Container, { children: [_jsxs(InfoBox, { children: [_jsxs(InfoTitle, { children: [_jsx(FaInfoCircle, {}), "RAPNET CSV Import Instructions"] }), _jsxs(InfoContent, { children: [_jsx("p", { children: "Upload RAPNET CSV files to bulk import diamonds into your inventory. The system will:" }), _jsxs("ul", { children: [_jsx("li", { children: "Parse all diamond specifications (shape, carat, color, clarity, cut, etc.)" }), _jsx("li", { children: "Validate data and flag any errors" }), _jsx("li", { children: "Calculate pricing based on per-carat rates" }), _jsx("li", { children: "Generate unique stock numbers if not provided" }), _jsx("li", { children: "Store diamond images and certificate references" }), _jsx("li", { children: "Provide detailed import summary with success/failure counts" })] }), _jsx("p", { style: { marginTop: '0.75rem', fontWeight: 600 }, children: "Supported formats: RAPNET standard CSV export format" })] })] }), _jsxs(Section, { children: [_jsx(SectionHeader, { children: _jsxs(SectionTitle, { children: [_jsx(FaCheckDouble, {}), "Import with Validation (Recommended)"] }) }), _jsx(CSVValidator, {})] }), _jsxs(Section, { children: [_jsx(SectionHeader, { children: _jsxs(SectionTitle, { children: [_jsx(FaFileImport, {}), "Direct Import (Skip Validation)"] }) }), _jsx(CSVImporter, {})] }), _jsxs(Section, { children: [_jsx(SectionHeader, { children: _jsxs(SectionTitle, { children: [_jsx(FaFileExport, {}), "Export Options"] }) }), _jsxs("div", { style: {
                            padding: '2rem',
                            textAlign: 'center',
                            background: 'var(--bg-tertiary)',
                            borderRadius: '8px',
                            border: '1px dashed var(--border-color)'
                        }, children: [_jsx(FaFileExport, { style: {
                                    fontSize: '2.5rem',
                                    color: 'var(--text-tertiary)',
                                    opacity: 0.4,
                                    marginBottom: '1rem'
                                } }), _jsx("h3", { style: { margin: 0, color: 'var(--text-secondary)' }, children: "Bulk Export" }), _jsx("p", { style: { margin: '0.5rem 0 1rem 0', color: 'var(--text-tertiary)', fontSize: '0.875rem' }, children: "Export inventory to CSV, RAPNET format, or custom templates" }), _jsxs("button", { onClick: () => notify.info('Coming Soon', 'Bulk export from this page will be available in a future update. You can export from the Diamond Inventory page.'), style: {
                                    padding: '0.75rem 1.5rem',
                                    background: 'var(--bg-secondary)',
                                    border: '1px solid var(--border-color)',
                                    borderRadius: '6px',
                                    color: 'var(--text-secondary)',
                                    cursor: 'pointer',
                                    fontSize: '0.875rem'
                                }, children: [_jsx(FaFileExport, { style: { marginRight: '0.5rem' } }), "Export Inventory"] })] })] })] }));
};
export default ImportManagement;
